"use client";

import { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Button } from "@/components/ui/button";
export default function Casestudyshowcase() {
  const sectionRef = useRef<HTMLElement | null>(null);
  const prefersReducedMotion = useReducedMotion();
  const tiles = [{
    id: "tile-a",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_sistemas_pulverizacao.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_sistemas_pulverizacao.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_sistemas_pulverizacao.png-wvc-sizes",
    alt: "Renderização técnica de sistemas de engenharia industrial Eurocontrol",
    caption: "Sistemas de Engenharia",
    className: "md:col-span-4 md:row-span-2 aspect-[4/3] md:aspect-auto md:min-h-[560px]",
    isHero: true
  }, {
    id: "tile-b",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/controlo_pulverizacao_precisao.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/controlo_pulverizacao_precisao.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/controlo_pulverizacao_precisao.webp-wvc-sizes",
    alt: "Interface de controlo de precisão para pulverização industrial",
    caption: "Controlo de Precisão",
    className: "md:col-span-2 aspect-[4/3]",
    isHero: false
  }, {
    id: "tile-c",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/bicos_pulverizadores_industriais.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/bicos_pulverizadores_industriais.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/bicos_pulverizadores_industriais.png-wvc-sizes",
    alt: "Close-up de bicos pulverizadores de alta performance",
    caption: "Bicos Pulverizadores",
    className: "md:col-span-2 aspect-[4/3]",
    isHero: false
  }, {
    id: "tile-d",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/aplicacoes_industriais_setor.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/aplicacoes_industriais_setor.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/aplicacoes_industriais_setor.png-wvc-sizes",
    alt: "Visualização de aplicações industriais em ambiente fabril",
    caption: "Aplicações Industriais",
    className: "md:col-span-3 aspect-[16/9]",
    isHero: false
  }, {
    id: "tile-e",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/sustentabilidade_processos.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/sustentabilidade_processos.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/sustentabilidade_processos.png-wvc-sizes",
    alt: "Dashboard de eficiência e sustentabilidade em processos",
    caption: "Eficiência e Sustentabilidade",
    className: "md:col-span-3 aspect-[16/9]",
    isHero: false
  }];
  useEffect(() => {
    if (!sectionRef.current) return;
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(() => {
      const mm = gsap.matchMedia();
      mm.add({
        reduce: "(prefers-reduced-motion: reduce)",
        motion: "(prefers-reduced-motion: no-preference)"
      }, context => {
        const conditions = context.conditions as {
          reduce: boolean;
          motion: boolean;
        };
        if (conditions.reduce) {
          gsap.set("[data-reveal='intro'], [data-reveal='tile']", {
            opacity: 1,
            y: 0,
            clearProps: "all"
          });
          return;
        }
        gsap.from("[data-reveal='intro']", {
          opacity: 0,
          y: 24,
          duration: 0.7,
          ease: "cubic-bezier(0.22,0.61,0.36,1)",
          stagger: 0.08,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 82%"
          }
        });
        gsap.from("[data-reveal='tile']", {
          opacity: 0,
          y: 32,
          duration: 0.7,
          ease: "cubic-bezier(0.22,0.61,0.36,1)",
          stagger: 0.1,
          scrollTrigger: {
            trigger: "[data-grid='bento']",
            start: "top 85%"
          }
        });
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);
  return;
}